<obg-m-dropdown-menu #menu (opened)="opened=$event">
	<button
		class="obg-m-user-summary-toggle-button"
		test-id="user-summary-toggle-button"
		data-test-id="user-summary-toggle-button"
		mat-flat-button
		color="primary"
		[obgInteraction]="accountInteraction"
		trigger
	>
		<span class="ico-profile has-balance"></span>
		<span class="obg-m-user-summary-running-balance-title" *ngIf="showRunningBalanceMsg && isGameLaunched">
			{{'general.balance' | translate }}
		</span>
		<ng-container *ngIf="!isGameLaunched">
			<span *ngIf="balance$ | async as balance" class="obg-m-user-summary-balance" obgSensitiveData
				>{{ balance.totalAmount | obgCurrency }}</span
			>
		</ng-container>
		<span class="ico-chevron-right" [class.rotate-ico-90]="!opened" [class.rotate-ico-270]="opened"></span>
	</button>
	<div class="obg-m-user-summary-menu" menu>
		<obg-m-funds-overview
			class="obg-m-user-summary-funds-overview"
			[balance]="balance$ | async"
			[customer]="customer$ | async"
			[options]="fundsOverviewOptions"
			[withdrawRoute]="withdrawRoute"
			[depositRoute]="depositRoute"
			(deposit)="menu.closeMenu()"
			(withdraw)="menu.closeMenu()"
		>
		</obg-m-funds-overview>
		<mat-divider></mat-divider>
		<obg-m-content-menu-items
			[menuItems]="menuItems$ | async"
			(selectedItem)="menuItemSelected($event)"
		></obg-m-content-menu-items>
	</div>
</obg-m-dropdown-menu>
